import * as React from "react";
import { usePromptGeneratorContext } from "@/components/feature/promptGenerator/hooks";

interface Props {
  handleSendMessage: (message: string) => void;
}

export const SidebarPromptImprovementHandler: React.FC<Props> = ({ handleSendMessage }) => {
  const { promptToImprove, sendPromptToImprove } = usePromptGeneratorContext();

  React.useEffect(() => {
    if (promptToImprove) {
      handleSendMessage(promptToImprove);
      sendPromptToImprove(null);
    }
  }, [handleSendMessage, promptToImprove, sendPromptToImprove]);

  return null;
};
